import { IS_PROD_ENV } from '@app/environment/typed-env';
import { useAuthorizedUser } from '@app/auth/useAuthorizedUser';
import { ONE_DAY_IN_MS } from '../../subscription/discount/first-day-discount.constant';

const DEV_SHORT_DELAY_MS = 5e3;

export const useShouldShowTopBanner = () => {
  const { currentUser } = useAuthorizedUser();

  if (currentUser?.upsellTopBannerHiddenDate) {
    try {
      const hiddenDate = new Date(currentUser.upsellTopBannerHiddenDate);
      const delta = Date.now() - hiddenDate.getTime();
      if (delta < (IS_PROD_ENV ? ONE_DAY_IN_MS : DEV_SHORT_DELAY_MS)) {
        return false;
      }
    } catch {}
  }

  return true;
};
